import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import SvgCircleSuccessSolid from '../../icons/svgCircleSuccessSolid';
import Big from 'big.js';
import Loader from '../../components/loader';
import Countdown from '../../components/countdown';
import LoaderRing from '../../components/loaderring';
import DiscountModal from './discountmodal';

import SvgInfoOutline from '../../icons/svgInfoOutline';

class PreviewOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { orders, checkOrder, tradeSuccess } = this.props;
    const { pair } = this.state;
  }

  render() {
    const {
      toggleModal,
      modalComponent,
      user,
      otcDisabled,
      quote,
      exchA,
      exchB,
      tradeAlt,
      tradeAmount,
      tradeSpend,
      countdownExpired,
      fiatSelected,
      newOrder,
      submitOrder,
      tradeSuccess,
      checkCountdown,
      editOrder,
      getQuoteFiat,
      checkOrder,
      tradeType,
      assetValue,
      currencySign,
      isOfType,
      humName,
      feeTaker,
      takerTiers,
      otcFail,
      pristine,
      submitLoading,
      promoCode,
    } = this.props;

    // TODO
    let buyCompleted = (tradeAmount > 0) && exchA && exchB && !countdownExpired && !otcDisabled;
    if (tradeAlt) {
      buyCompleted = (tradeSpend > 0) && exchA && exchB && !countdownExpired && !otcDisabled;
    }
    //

    let currency;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currency = user.me.defaults.currencyHandle;
    }

    let useCurr;
    switch (currency) {
      case 'CENT':
        useCurr = 'USD';
        break;
      case 'EURCENT':
        useCurr = 'EUR';
        break;
      default:
        useCurr = 'EUR';
        break;
    }

    let assetRate;
    if (assetValue) {
      if (tradeType === 'BUY') {
        assetRate = new Big(assetValue.bid);
      }
      if (tradeType === 'SELL') {
        assetRate = new Big(assetValue.ask);
      }
    }

    // let fiatTotal;
    // if (assetRate && quote) {
    //   fiatTotal = Number(quote.total / assetRate).toFixed(2);
    // }

    let humA = exchA;
    let humB = exchB;

    if (humA === 'silv') {
      humA = 'silver';
    }
    if (humB === 'silv') {
      humB = 'silver';
    }

    let useTaker;
    let orderFee;
    let orderSpend;
    let orderTotalFee;
    if (feeTaker) {
      useTaker = takerTiers(feeTaker);
    }
    if (useTaker) {
      orderFee = new Big(useTaker);
    }
    if (tradeSpend) {
      orderSpend = new Big(tradeSpend);
    }

    let useSpend;
    let humAmount;
    let grossAmount;
    let grossSpend;

    let quoteQuantity;
    let quoteTicker;
    let quoteMatch;
    if (quote) {
      if (quote.quantity) {
        quoteQuantity = new Big(quote.quantity);
      }
      if (quote.ticker) {
        quoteTicker = new Big(quote.ticker);
      }
      if (quote.match) {
        quoteMatch = quote.match;
      }
    }

    let fiatTotal;
    if (tradeType === 'BUY') {
      if (quoteMatch === 'receive') {
        if (quoteQuantity && quoteTicker) {
          useSpend = quoteQuantity.times(quoteTicker);
          humAmount = quoteQuantity;
        }
      }
      if (quoteMatch === 'spend') {
        if (quoteQuantity && quoteTicker) {
          useSpend = quoteQuantity;
          humAmount = quoteQuantity.div(quoteTicker);
        }
      }
      if (assetRate && useSpend) {
        fiatTotal = useSpend.div(assetRate);
      }

      //
      if (orderFee && humAmount) {
        orderTotalFee = humAmount.times(orderFee).div(100);
      }

      if (humAmount && orderTotalFee) {
        grossAmount = humAmount.minus(orderTotalFee);
      }
      if (useSpend) {
        grossSpend = useSpend;
      }
    }

    if (tradeType === 'SELL') {
      if (quoteMatch === 'spend') {
        if (quoteQuantity && quoteTicker) {
          useSpend = quoteQuantity.times(quoteTicker);
          humAmount = quoteQuantity;
        }
      }
      if (quoteMatch === 'receive') {
        if (quoteQuantity && quoteTicker) {
          useSpend = quoteQuantity;
          humAmount = quoteQuantity.div(quoteTicker);
        }
      }
      if (assetRate && useSpend) {
        fiatTotal = useSpend.div(assetRate);
      }

      //
      if (orderFee && useSpend) {
        orderTotalFee = useSpend.times(orderFee).div(100);
      }

      if (useSpend && orderTotalFee) {
        grossSpend = useSpend.minus(orderTotalFee);
      }
      if (humAmount) {
        grossAmount = humAmount;
      }
    }

    // if (orderFee && humAmount) {
    //   orderTotalFee = humAmount.times(orderFee).div(100);
    // }
    // if (humAmount && orderTotalFee) {
    //   if (tradeType === 'BUY') {
    //     grossAmount = humAmount.minus(orderTotalFee);
    //   }
    //   if (tradeType === 'SELL') {
    //     grossAmount = humAmount.minus(orderTotalFee);
    //   }
    // }

    const previewFail = !useSpend || !grossAmount || !useCurr || !fiatTotal || !orderFee || !orderTotalFee;

    let usePromotion;

    if (quote && quote.promotion && (Object.keys(quote.promotion).length > 0)) {
      usePromotion = quote.promotion;
    }


    let promoName;
    let promoReward;
    let promoRewardAmount;
    let usePromoHandle;
    if (usePromotion) {
      if (usePromotion && usePromotion.name) {
        promoName = usePromotion.name;
      }
      if (usePromotion && usePromotion.reward) {
        promoReward = usePromotion.reward;
      }
      if (usePromotion && usePromotion.rewardAmount) {
        promoRewardAmount = usePromotion.rewardAmount;
        if (promoRewardAmount && promoRewardAmount.handle) {
          switch (promoRewardAmount.handle) {
            case 'AUG':
              usePromoHandle = 'GOLD';
              break;
            case 'AGG':
              usePromoHandle = 'SILV';
              break;
            case 'BTS':
              usePromoHandle = 'BTC';
              break;
            default:
              usePromoHandle = promoRewardAmount.handle;
              break;
          }
        }
      }
    }

    let promoFail;
    if (quote) {
      if (quote.promoCodeSuccess === false) {
        promoFail = true;
      }
    }

    let variablePricing;
    if (quote && quote.pricingMeta && (Object.keys(quote.pricingMeta).length > 0)) {
      variablePricing = quote.pricingMeta;
    }
    let vPricingDiscount;
    if (variablePricing && variablePricing.pricingDiscount) {
      vPricingDiscount = variablePricing.pricingDiscount;
    }
    let vOGTicker;
    if (variablePricing && variablePricing.originalTicker) {
      vOGTicker = Number(variablePricing.originalTicker);
    }
    let vSpend;
    if (vOGTicker && quoteQuantity) {
      vSpend = quoteQuantity.times(vOGTicker);
    }

    if (!quote) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    return (
      <div className="qt-preview">
        {previewFail && (
          <div className="status warn">
            <span>
              Vaultoro Direct encountered a problem.
              <br />
            </span>
            Please check back later, or contact support if problem persists.
          </div>
        )}
        {promoFail ? (
          <div className="status warn">
            {promoCode ? (
              <>
                Promo code <span>{promoCode}</span> does not exist.
              </>
            ) : (
              <>
                Your promo code does not exist.
              </>
            )}
          </div>
        ) : (null)}
        <div style={{marginBottom: '30px'}}>
          <p style={{marginTop: '0px'}}>
            Please confirm your purchase.
          </p>
        </div>
        <div>
          <div>
            <div className="lr-p">
              {isOfType(exchA, 'METAL') ? (
                <span>
                  Price (
                  {humB.toUpperCase()}
                  /g)
                </span>
              ) : (
                <span>
                  Price (
                  {humA.toUpperCase()}
                  )
                </span>
              )}
              <span>
                {/* {quote.price} */}
                {useSpend ? (
                  useSpend.toFixed(8)
                ) : (
                  ''
                )}
              </span>
            </div>
            <div className="lr-p">
              {countdownExpired ? (
                <span className="mute">
                  Quote expired, please refresh quote
                </span>
              ) : (
                <>
                  <div
                    style={
                      {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }
                    }
                  >
                    {quote && quote.expires ? (
                      <LoaderRing
                        deadline={quote.expires}
                        loops={1}
                      />
                    ) : null }
                    <span className="mute" style={{ paddingLeft: 4 }}>
                      Valid for the next&nbsp;
                    </span>
                    <span className="mute">
                      <Countdown
                        deadline={quote.expires}
                        checkCountdown={checkCountdown}
                      />
                    </span>
                  </div>
                  <span className="mute">
                    &#8776;&nbsp;
                    {Number(fiatTotal).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    )}
                    &nbsp;
                    {useCurr}
                  </span>
                </>
              )}
            </div>
          </div>
          <hr />
          <div>
            <div className="lr-p">
              <span>
                Fee
              </span>
              <span>
                {orderFee ? orderFee.toString() : ''}
                %
              </span>
            </div>
            <div className="lr-p">
              <span className="mute" />
              <span className="mute">
                &#8776;&nbsp;
                {orderTotalFee ? orderTotalFee.toFixed(8) : ''}
                {tradeType === 'BUY' ? (
                  <>
                    {isOfType(exchA, 'METAL') ? (
                      'g'
                    ) : (
                      ` ${humA.toUpperCase()}`
                    )}
                  </>
                ) : (
                  <>
                    {isOfType(exchA, 'METAL') ? (
                      'g'
                    ) : (
                      ` ${humA.toUpperCase()}`
                    )}
                  </>
                )}
              </span>
            </div>
          </div>
          {usePromotion ? (
            <>
              <hr />
              <div>
                <div className="lr-p lr-p-mc">
                  <div>
                    Promo Code/Coupon
                  </div>
                  <div>
                    <div className="pre-promo">
                      <div>
                        <SvgCircleSuccessSolid className="vt-accent" />
                      </div>
                      <div>
                        <p>
                          <span>
                            {promoName || ''}
                          </span>
                          &nbsp;applied
                        </p>
                        <p className="mute">
                          {usePromoHandle && promoRewardAmount && promoRewardAmount.value ? (
                            <>
                              {isOfType(usePromoHandle, 'METAL') ? (
                                `${promoRewardAmount.value}g `
                              ) : (
                                `${promoRewardAmount.value}`
                              )}
                            </>
                          ) : (null)}
                          {usePromoHandle ? (
                            ` ${usePromoHandle}`
                          ) : (null)}
                          {promoReward.type && promoReward.type === 'percentage' ? (
                            <>
                              {promoReward && promoReward.value ? (
                                ` (${promoReward.value}% Reward)`
                              ) : (null)}
                            </>
                          ) : (
                            ` (Reward)`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (null)}
          <hr />
          <div>
            <div className="lr-p">
              <span>
                Execution
              </span>
              <span className="vt-accent">
                Instant
              </span>
            </div>
          </div>
          <div className="qt-p-sum">
            <div>

                <div>
                  <div className={`card-coin ${humName(humB).replace(/\s/g, "-").toLowerCase()}`}>
                    <img alt={humName(humB)} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${humName(humB).replace(/\s/g, "-").toLowerCase()}.svg`} />
                  </div>
                </div>
                <div
                  className={vPricingDiscount && tradeType === 'BUY' ? ('qtp-discounted') : ('')}
                >
                  <div>
                    {tradeType === 'BUY' ? (
                      <>
                        {grossSpend ? (
                          grossSpend.toFixed(8)
                        ) : (
                          ''
                        )}
                        {isOfType(humB, 'METAL') ? (
                          'g '
                        ) : (' ')}
                        {humB.toUpperCase()}
                      </>
                    ) : (
                      <>
                        {grossAmount ? (
                          grossAmount.toFixed(8)
                        ) : (
                          ''
                        )}
                        {isOfType(humB, 'METAL') ? (
                          'g '
                        ) : (' ')}
                        {humB.toUpperCase()}
                      </>
                    )}
                  </div>
                  {tradeType === 'BUY' ? (
                    <>
                      {vPricingDiscount ? (
                        <div
                          className="qtp-discount"
                          onClick={() => toggleModal(
                            <DiscountModal
                              toggleModal={toggleModal}
                              modalComponent={modalComponent}
                              variablePricing={variablePricing}
                              vPricingDiscount={vPricingDiscount}
                              vOGTicker={vOGTicker}
                              vSpend={vSpend}
                              useSpend={useSpend}
                              humA={humA}
                              humB={humB}
                              isOfType={isOfType}
                              tradeType={tradeType}
                            />
                            , false
                          )}
                              >
                          <span>
                            {vSpend ? (
                              vSpend.toFixed(8)
                            ) : (null)}
                            {isOfType(humB, 'METAL') ? (
                              'g '
                            ) : (' ')}
                            {humB.toUpperCase()}
                          </span>
                          &nbsp;({vPricingDiscount}% OFF)
                          <SvgInfoOutline />
                        </div>
                      ) : null}
                    </>
                  ) : (null)}
                </div>

            </div>
            <div>
              <FontAwesomeIcon
                size="sm"
                icon={faChevronRight}
                className="vt-accent"
              />
            </div>
            <div>
              <div>
                <div className={`card-coin ${humName(humA).replace(/\s/g, "-").toLowerCase()}`}>
                  <img alt={humName(humA)} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${humName(humA).replace(/\s/g, "-").toLowerCase()}.svg`} />
                </div>
              </div>
              <div
                className={vPricingDiscount && tradeType === 'SELL' ? ('qtp-discounted') : ('')}
              >
                <div>
                  {tradeType === 'BUY' ? (
                    <>
                      {grossAmount ? (
                        grossAmount.toFixed(8)
                      ) : (
                        ''
                      )}
                      {isOfType(humA, 'METAL') ? (
                        'g '
                      ) : (' ')}
                      {humA.toUpperCase()}
                    </>
                  ) : (
                    <>
                      {grossSpend ? (
                        grossSpend.toFixed(8)
                      ) : (
                        ''
                      )}
                      {isOfType(humA, 'METAL') ? (
                        'g '
                      ) : (' ')}
                      {humA.toUpperCase()}
                    </>
                  )}
                </div>
                {tradeType === 'SELL' ? (
                  <>
                    {vPricingDiscount ? (
                      <div
                        className="qtp-discount"
                        onClick={() => toggleModal(
                          <DiscountModal
                            toggleModal={toggleModal}
                            modalComponent={modalComponent}
                            variablePricing={variablePricing}
                            vPricingDiscount={vPricingDiscount}
                            vOGTicker={vOGTicker}
                            vSpend={vSpend}
                            useSpend={useSpend}
                            humA={humA}
                            humB={humB}
                            isOfType={isOfType}
                            tradeType={tradeType}
                          />
                          , false
                        )}
                            >
                        <span>
                          {vSpend ? (
                            vSpend.toFixed(8)
                          ) : (null)}
                          {isOfType(humA, 'METAL') ? (
                            'g '
                          ) : (' ')}
                          {humA.toUpperCase()}
                        </span>
                        &nbsp;({vPricingDiscount}% BONUS)
                        <SvgInfoOutline />
                      </div>
                    ) : null}
                  </>
                ) : (null)}
              </div>
            </div>
          </div>
        </div>
        { tradeSuccess ? (
          <div className="button-area">
            <button type="button" className="vlt-btn" onClick={() => newOrder()}>
              <span>
                New Trade
              </span>
            </button>
          </div>
        ) : (
          <div className="button-area">
            { otcFail || previewFail ? (
              <>
                <button type="button" style={{ width: '100%' }} className="vlt-btn vlt-btn-outline" onClick={() => editOrder()}>
                  <span>
                    New Trade
                  </span>
                </button>
              </>
            ) : (
              <>
                <button type="button" className="vlt-btn vlt-btn-outline" onClick={() => editOrder()}>
                  <span>
                    Cancel
                  </span>
                </button>
                { countdownExpired ? (
                  <button type="button" className="vlt-btn vlt-btn-outline" onClick={checkOrder}>
                    <span>
                      Refresh Quote
                    </span>
                  </button>
                ) : (
                  <span>
                    { fiatSelected ? (
                      <button type="button" className="vlt-btn" disabled={!buyCompleted || pristine} onClick={() => getQuoteFiat('BUY')}>
                        <span>
                          Confirm Trade
                        </span>
                      </button>
                    ) : (
                      <button type="button" className="vlt-btn" disabled={!buyCompleted || pristine} onClick={() => submitOrder()}>
                        {submitLoading ? (
                          <span>
                            <Loader logo small />
                          </span>
                        ) : (
                          <span>
                            Confirm Trade
                          </span>
                        )}
                      </button>
                    )}
                  </span>
                )}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
  quote: state.order.quote,
  assetValue: state.order.assetValue,
});

export default connect(mapStateToProps)(PreviewOrder);
